export default {
  errorDefault: 'Došlo je do greške',
  unknown: 'Nepoznato',
};
